import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const NewsList = resolve=>{require(['@/views/News/newstitle.vue'],resolve)};
const NewsListA = resolve=>{require(['@/views/News/newstitle.1.vue'],resolve)};
const Error = resolve=>{require(['@/views/Error/50x.vue'],resolve)};
const Index = resolve=>{require(['@/views/index.vue'],resolve)};
const ABouta = resolve=>{require(['@/views/about/index.vue'],resolve)};
const Product = resolve=>{require(['@/views/product.vue'],resolve)};
const Solve = resolve=>{require(['@/views/solve.vue'],resolve)};
const News = resolve=>{require(['@/views/News/news.vue'],resolve)};
const NewsA = resolve=>{require(['@/views/News/news.1.vue'],resolve)};
const Down = resolve=>{require(['@/views/download.vue'],resolve)};
const Cooper = resolve=>{require(['@/views/cooperation.vue'],resolve)};
const Job = resolve=>{require(['@/views/job.vue'],resolve)};
const Help = resolve=>{require(['@/views/help.vue'],resolve)};
const Register = resolve=>{require(['@/views/register.vue'],resolve)};
// const productDoc = resolve=>{require(['@/views/doc/product_doc.vue'],resolve)};
// const apiDocBak = resolve=>{require(['@/views/doc/api_doc.vue'],resolve)};
// const techDoc = resolve=>{require(['@/views/doc/technical_specifications_doc.vue'],resolve)};
// const debugTool = resolve=>{require(['@/views/doc/debug_tool.vue'],resolve)};
const openDoc = resolve=>{require(['@/views/doc/api_doc_new.vue'],resolve)};


const routes = [
	{path: '/', component: Index, name: 'index', props: true},
	{path: '/about', component: ABouta},
	{path: '/product', component: Product},
	{path: '/solve', component: Solve},
	{path: '/news/news', component: News},
	{path: '/news/newlist', component: NewsList},
	{path: '/news/newsA', component: NewsA},
	{path: '/news/newlistA', component: NewsListA},
	{path: '/download', component: Down},
	{path: '/cooperation', component: Cooper},
	{path: '/job', component: Job},
	{path: '/help', component: Help},
	{path: '/register', component: Register},
	{path: '/productDoc', component: openDoc},
	{path: '/apiDoc', component: openDoc},
	{path: '/techDoc', component: openDoc},
	{path: '/debugTool', component: openDoc},
	{path:'*',component:Error},
	{path: '/openDoc', component: openDoc},
];
const base = '/pay/'

const router = new Router({base: base,routes: routes});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js